import React, { useState } from 'react'
import TopMenu from './TopMenu'
import NavbarMenu from './NavbarMenu'
import Footer from './Footer'
import login from '../img/login2.jpg'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import ReCAPTCHA from "react-google-recaptcha";


import { Col, Row, Label, Input, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2';


function Login() {
    const navigate = useNavigate();
    //navigate('/dashboard')
    const [logData, setLogData] = useState({ email: '', password: '' });

    const handalSubmit = async () => {
        if (logData.email === '' || logData.password === '') {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please enter email or password!",
                footer: ''
            });
            return
        }

        const res = await axios.post(`https://ngt.botberries.com/smartcard/login`, logData);
        console.log(res.data.error);
        if (res.data.error === 1) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please enter email or password!",
                footer: ''
            });
            return
        }
        localStorage.setItem('userdata', JSON.stringify(res.data.result))
        setTimeout(() => {
            navigate('/dashboard')
        }, 100);
    }
    const onChange = () => {
        console.log()
    }
    return (
        <div>
            <TopMenu />
            <NavbarMenu />
            <div className='bg-about'>
                <div className='container pt-5 about-a'>
                    <h2 className='text-light'>Login</h2>
                    <p className='text-light'>Home / Login</p>
                </div>
            </div>
            <div>
                <div className='container pt-5 pb-5'>
                    <div className='row'>
                        <div className='col-sm-7 '>
                            <img src={login} className='width-100' />
                        </div>
                        {/* <div className='col-sm-7 '>
                            <div className='contact-form'>
                                <h4 className='text-center'>Register new user</h4>
                               
                                <Row className="">
                                    <Col sm={6}>
                                        <Label>
                                            First name
                                        </Label>
                                        <Input
                                            type='text' placeholder='Full name'
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Label>
                                            Last Name
                                        </Label>
                                        <Input
                                            type='text' placeholder='Full name'
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Label>
                                            Email
                                        </Label>
                                        <Input
                                            type='text' placeholder='Full name'
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Label>
                                            Phone
                                        </Label>
                                        <Input
                                            type='text' placeholder='Phone number'
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Label>
                                            Password
                                        </Label>
                                        <Input
                                            type='password' placeholder='*********'
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Label>
                                        Confirm Password
                                        </Label>
                                        <Input
                                            type='password' placeholder='*********'
                                        />
                                    </Col>
                                   
                                    <Col sm={12} className='pt-5'>
                                        <Button type='button' block color='primary'>Submit</Button>
                                    </Col>

                                </Row>
                            </div>
                        </div> */}
                        <div className='col-sm-4 offset-sm-1'>
                            <div className='contact-form_'>
                                <h4 className='text-center'>Login</h4>
                                <Row className="">

                                    <Box
                                        component="form"
                                        sx={{ '& > :not(style)': { m: 1, width: '100%' } }}
                                        noValidate
                                        autoComplete="off"
                                    >

                                        <TextField label="User name" variant="standard"
                                            value={logData.email}
                                            onChange={(e) => { setLogData((prev) => ({ ...prev, email: e.target.value })) }} />
                                        <TextField label="Password" variant="standard"
                                            value={logData.password}
                                            onChange={(e) => { setLogData((prev) => ({ ...prev, password: e.target.value })) }} />
                                        <div>
                                            <ReCAPTCHA
                                                sitekey="6Ldp47MsAAAAAJLp3K6lwciznGbRByEu36n062fb"
                                                onChange={onChange}
                                            />
                                            {/* 6LcoPbMsAAAAAG4CYiLePRAwtr_iqKKsXezoLod3 */}
                                        </div>
                                    </Box>

                                    <Col sm={12} className='pt-5'>
                                        <Button type='button' block color='primary'
                                            onClick={handalSubmit}>Login</Button>
                                    </Col>

                                </Row>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Login